module.exports = __webpack_public_path__ + "static/img/bg_default.ccf631e6.png";